import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="relative w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Często zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Odpowiedzi na najczęściej pojawiające się pytania dotyczące USFans Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-150"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-add-line text-lg text-foreground-500 transition-transform duration-200 ${
                      openId === item.id ? "rotate-45" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* FAQ Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map((item) => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}